import React from 'react'
import { useDispatch } from 'react-redux'
import { getPendingReviews } from '../../../../../../redux/actions/release'
import './style.sass'
import CustomButton from '../../../../../common/CustomButton'

const ReviewListErrorState = () => {
  const dispatch = useDispatch()

  return (
    <div className="pending-review-list-error-state-container">
      <div className="wrapper">
        <div className="card-container">
          <h5>Oh no! Couldn't load the pending reviews :(</h5>
          <p>
            Something went wrong while retrieving your pending reviews.
            You can refresh page or if you already refreshed the page please wait few minutes and refresh page again.
          </p>
          
          <CustomButton
            onClick={() => dispatch(getPendingReviews())}
            buttonText="Try refreshing"
            className="btn btn-fill"
          />
        </div>
      </div>
    </div>
  )
}

export default ReviewListErrorState
